export const getOrangeLensProducts = (itemIds) => {
  return itemIds?.map((itemId) => {
    return {
      productInfo: {
        sku: itemId
      }
    };
  });
};